import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
})
export class Label {
  @Input() translationCode: string;
  @Input() optional: boolean;
}
